(function () {
  'use strict';
function translator(section) {
  const node = section && section.querySelector('[data-manual-i18n]');
  let messages = {};
  try { messages = node ? JSON.parse(node.textContent) : {}; } catch (_) { /* Keep English during a rolling theme update. */ }
  // Shopify's t filter HTML-escapes translations even inside a JSON script.
  const decoder = document.createElement('textarea');
  Object.keys(messages).forEach(key => {
    decoder.innerHTML = messages[key];
    messages[key] = decoder.value;
  });
  const fallback = {"eyebrow": "ATOTO PRODUCT SUPPORT", "title": "Find your manual.", "book_art": "USER MANUAL", "tagline": "READY WHEN YOU ARE.", "find_label": "Find a product manual", "model_placeholder": "For example, X10DG110E-A", "model_label": "Product model", "search": "Search manuals", "model_help": "Your model is on the product label or packaging.", "category": "Product category", "series": "Product series", "all_series": "All series", "clear_filters": "Clear filters", "manuals_title": "Product manuals", "pagination_label": "Manual search pages", "js_required": "Please enable JavaScript to search manuals, or visit our support library.", "support_library": "Open support library", "firmware_title": "Looking for firmware?", "firmware_help": "Get software updates and installation guidance.", "updates_library": "Visit the updates library", "help_title": "Need a hand?", "help_text": "Can't find your model? Our support team can help.", "contact": "Contact support", "return": "All product manuals", "full_search": "Search this manual", "unavailable": "This manual is currently unavailable.", "search_unavailable": "Manual search is temporarily unavailable.", "library_title": "Find manuals in our support library", "library_help": "Please use the library while search is unavailable.", "filters_reload": "Manual filters are temporarily unavailable. Please reload to try again.", "catalogue_updating": "The manual catalogue is being updated. Please try again shortly.", "loading": "Loading manuals…", "filters_unavailable": "Manual filters are temporarily unavailable.", "retry": "Try again", "not_yet": "This manual is not available yet.", "online_pdf": "Online + PDF", "online": "Online reading", "pdf_available": "PDF available", "fallback": "{{ requested }} unavailable · showing {{ current }}", "read": "Read online", "read_label": "Read {{ model }} manual in {{ language }}", "pdf": "Open PDF", "pdf_label": "Open {{ model }} manual PDF in {{ language }} (new tab)", "online_not_yet": "Online reading is not available yet", "empty_title": "No matching manuals", "empty_help": "Check the model on your product label, try a shorter model number, or clear the filters.", "clear_all": "Clear search & filters", "previous": "Previous", "next": "Next", "page": "Page {{ page }} of {{ pages }}", "manual_count": "Manuals: {{ count }}", "illustration": "Manual illustration", "reader_fallback": "This manual is not available in {{ requested }}. Showing {{ current }}.", "car_stereo": "Car Stereo", "portable": "Portable CarPlay Screen", "ai_box": "CarPlay / Android Auto AI Box", "accessories": "Accessories", "series_name": "{{ series }} Series", "camera": "Car Camera", "obd": "Bluetooth OBD", "tpms": "TPMS", "ambient": "Ambient Light", "led": "Programmable LED Sign", "amplifiers": "Car Amplifiers", "microphone": "Microphone", "search_empty": "No matching text in this manual."};
  return (key, values = {}) => String(messages[key] || fallback[key] || key).replace(/__(\w+)__|{{\s*(\w+)\s*}}/g, (match, token, liquid) => {
    const name = (token || liquid).toLowerCase();
    return Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match;
  });
}
function displayLanguage(code, locale) {
  try { return new Intl.DisplayNames([locale || 'en'], {type: 'language'}).of(code); }
  catch (_) { return code; }
}

  var reader = document.querySelector('[data-manual-reader]');
  var t = translator(reader);
  var rootPath = reader && reader.dataset.manualRoot || '/';
  rootPath = '/' + rootPath.split('/').filter(Boolean).join('/');
  if (rootPath === '/') rootPath = '';
  var centerPath = rootPath + '/pages/product-manual-and-update';
  var back = document.querySelector('[data-manual-return]');
  var returnPath = new URLSearchParams(location.search).get('manual_return');
  if (back) {
    back.href = centerPath;
    if (returnPath) {
      try {
        var target = new URL(returnPath, location.origin);
        if (target.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/product-manual-and-update$/.test(target.pathname)) {
          target.searchParams.delete('lang');
          back.href = centerPath + target.search;
        }
      } catch (_) { /* Keep the current market's manual-center link. */ }
    }
  }
  function languageFamily(value) {
    var code = String(value || '').toLowerCase().replace(/_/g, '-');
    if (/^zh(?:-|$)/.test(code)) return /(?:^|-)(hant|tw|hk|mo)(?:-|$)/.test(code) ? 'zh-hant' : 'zh-hans';
    return code.split('-')[0];
  }
  async function followMarketLanguage() {
    var article = document.querySelector('#docx-manual');
    var requested = reader && reader.dataset.manualLocale;
    var current = article && article.getAttribute('lang');
    var match = location.pathname.match(/\/pages\/manual-(\d+)-[a-z0-9-]+$/i);
    if (!requested || !current || !match || languageFamily(requested) === languageFamily(current)) return;
    var code = requested.toLowerCase().replace(/_/g, '-');
    var family = languageFamily(code);
    var candidates = family === 'zh-hant' ? [code, 'zh-tw', 'zh-hant']
      : family === 'zh-hans' ? [code, 'zh', 'zh-cn', 'zh-hans'] : [code, family];
    candidates = Array.from(new Set(candidates));
    for (var language of candidates) {
      if (!/^[a-z]{2,3}(?:-[a-z0-9]+)*$/.test(language)) continue;
      var url = new URL(rootPath + '/pages/manual-' + match[1] + '-' + language, location.origin);
      try {
        var response = await fetch(url.href, {signal: AbortSignal.timeout(8000)});
        if (!response.ok) continue;
        var page = new DOMParser().parseFromString(await response.text(), 'text/html');
        var translated = page.querySelector('#docx-manual');
        // Never navigate to a missing/unpublished translation or a locale redirect loop.
        if (!translated || languageFamily(translated.getAttribute('lang')) !== family) continue;
        url.search = location.search;
        url.searchParams.delete('lang');
        url.searchParams.set('manual_return', back ? new URL(back.href).pathname + new URL(back.href).search : centerPath);
        location.replace(url.href);
        return;
      } catch (_) { /* Try the next published language alias. */ }
    }
    var note = document.createElement('p');
    note.setAttribute('role', 'status');
    note.textContent = t('reader_fallback', {requested:displayLanguage(requested,requested), current:displayLanguage(current,requested)});
    reader.prepend(note);
  }
  followMarketLanguage();
  // Word's automatic image-description boilerplate is not customer-facing manual content.
  document.querySelectorAll('#docx-manual img').forEach(function (image) {
    ['alt', 'title'].forEach(function (attribute) {
      var label = image.getAttribute(attribute) || '';
      if (label.includes('AI 生成的内容可能不正确')) {
        if (attribute === 'alt') image.setAttribute('alt', t('illustration'));
        else image.removeAttribute(attribute);
      }
    });
  });
  var input = document.getElementById('manual-full-search');
  var body = document.querySelector('#docx-manual .manual-body');
  var results = document.getElementById('manual-full-results');
  if (!input || !body || !results) return;
  var blocks = Array.from(body.querySelectorAll('p,li,h1,h2,h3,h4,h5,h6,td,th')).filter(function (node) {
    return !node.querySelector('p,li,td,th') && node.textContent.trim();
  });
  input.addEventListener('input', function () {
    results.replaceChildren();
    var query = input.value.trim().toLocaleLowerCase();
    if (!query) return;
    var matches = blocks.filter(function (node) { return node.textContent.toLocaleLowerCase().includes(query); }).slice(0, 60);
    if (!matches.length) results.textContent = t('search_empty');
    matches.forEach(function (node) {
      var button = document.createElement('button');
      button.type = 'button'; button.textContent = node.textContent.trim().slice(0, 240);
      button.addEventListener('click', function () { node.scrollIntoView({block: 'center', behavior: 'smooth'}); });
      results.appendChild(button);
    });
  });
}());
